import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Main from './Debtor/Main';
import Form from './Debtor/Form';

// Utils
import {
    getData,
    getAlert,
    getDataWithComp
} from '../../../utils/SamuiUtils';
import { InitialDataDebtor } from '../../../model/InitialData/InitialDataDebtor';

const STORAGE_KEY = 'debtor-list';

function loadDebtorStorage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
            const o = JSON.parse(raw);
            return {
                listPage: o.listPage ?? 1,
                listItemsPerPage: o.listItemsPerPage ?? 50,
            };
        }
    } catch (_) {}
    return { listPage: 1, listItemsPerPage: 50 };
}

const Debtor = () => {
    const stored = loadDebtorStorage();
    const [mode, setMode] = useState('');
    const [dataMasterList, setDataMasterList] = useState([]);
    const [dataARtype, setDataARtype] = useState([]);
    const [listPage, setListPage] = useState(stored.listPage);
    const [listItemsPerPage, setListItemsPerPage] = useState(stored.listItemsPerPage);
    const [selectedData, setSelectedData] = useState(null);
    const [formData, setFormData] = useState(InitialDataDebtor());
    const [activeAfterSaveId, setActiveAfterSaveId] = useState(null);

    // บันทึก listPage, listItemsPerPage ลง localStorage (merge กับ searchTerm/sort จาก Main)
    useEffect(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            const o = raw ? JSON.parse(raw) : {};
            const next = { ...o, listPage, listItemsPerPage };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        } catch (_) {}
    }, [listPage, listItemsPerPage]);

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async (editedId) => {
        try {
            if (editedId != null) {
                setActiveAfterSaveId(editedId);
                await fetchRealtime();
            }
            setMode('S');
            if (editedId == null) fetchRealtime();
        } catch (error) {
            getAlert('FAILED', error.message);
        }
    };

    const fetchRealtime = async () => {
        try {
            // ดึงข้อมูลจาก Tb_Set_AR ทั้งหมด
            const masterList = await getDataWithComp("View_Set_AR", `ORDER BY AR_Code`);
            const dataARtype = await getData("Tb_Set_ARType", `1=1 AND Comp_Id = ${localStorage.getItem("company")}`);
            const arImage = await getDataWithComp("Tb_Set_ARImage", ``);
            if (masterList && masterList.length > 0) {
                setDataMasterList(masterList);
            }
            if (dataARtype && dataARtype.length > 0) {
                setDataARtype(dataARtype);
            }

            if (arImage && arImage.length > 0) {
                const updatedMasterList = masterList.map(item => {
                    const images = arImage.filter(image => image.ar_id === item.AR_Id);
                    return {
                        ...item,
                        AR_Image: images.map(image => ({
                            img_id: image.img_id,
                            file_url: image.file_url
                        }))
                    };
                });
                setDataMasterList(updatedMasterList);
            }
        } catch (error) {
            getAlert('FAILED', error.message);
        }
    };

    const onPageInsert = () => {
        setMode('I')
    };

    const onCancel = () => {
        setMode('S'); // กลับหน้ารายการโดยไม่ reload เพื่อรักษา currentPage
    };

    const onRowSelected = (item) => {
        setMode('U');
        setFormData({
            ar_id: item.Ar_Id,
            comp_id: window.localStorage.getItem('company'),
            ar_code: item.Ar_Code,
            ar_name: item.Ar_Name,
            ar_type: item.ARType_Name,
            ar_shortname: item.Ar_ShortName,
            ar_taxno: item.Ar_TaxNo,
            ar_add1: item.Ar_Add1,
            ar_add2: item.Ar_Add2,
            ar_add3: item.Ar_Add3,
            ar_province: item.Ar_Province,
            ar_zipcode: item.Ar_Zipcode,
            ar_contact1: item.Ar_Contact,
            ar_contact2: item.Ar_Contact2,
            ar_tel1: item.Ar_Tel1,
            ar_tel2: item.Ar_Tel2,
            ar_group: item.Ar_Group,
            ar_refsalecode: item.Ar_RefSaleCode,
            ar_area: item.Ar_Area,
            ar_status: item.Ar_Status,
            ar_credit: item.Ar_Credit,
            ar_vat: item.Ar_Vat,
            ar_discount: item.Ar_Discount,
            ar_branch: item.Ar_Branch,
            ar_bt_name: item.Ar_BT_Name,
            ar_addlat: item.AR_ADDLAT,
            ar_addlan: item.AR_ADDLAN,
            ar_refsaleName: item.AR_RefSaleName,
            ar_credit_term: item.AR_Credit_Term,
            ar_credit_limit: item.AR_Credit_Limit,
            ar_item_free: item.AR_Item_Free
        })
        setSelectedData(item);
    };

    return <div className="Creditor">
        <div className="wrapper">
            <Sidebar />
            <div className="main-panel">
                <div className="container">
                    <div className="page-inner">
                        <div style={{ display: mode === 'S' ? 'block' : 'none' }}>
                            <Main
                                masterList={dataMasterList}
                                name={'ข้อมูลลูกหนี้'}
                                onPageInsert={() => onPageInsert()}
                                onRowSelected={(item) => onRowSelected(item)}
                                activeAfterSaveId={activeAfterSaveId}
                                onClearActiveAfterSave={() => setActiveAfterSaveId(null)}
                                idField="AR_Id"
                                listPage={listPage}
                                listItemsPerPage={listItemsPerPage}
                                onListPageChange={setListPage}
                                onListItemsPerPageChange={setListItemsPerPage}
                            />
                        </div>
                        <div style={{ display: mode !== 'S' ? 'block' : 'none' }}>
                            <Form
                                callInitialize={initialize}
                                onCancel={onCancel}
                                mode={mode}
                                name={'ข้อมูลลูกหนี้'}
                                formData={formData}
                                setFormData={setFormData}
                                selectedData={selectedData}
                                dataARtype={dataARtype}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
};

export default Debtor;
